<template>
  <div ref="printMe" id="printMe">
    <div class="container">
    <section :id="isModeTyping ? 'form-input' : 'duong-so'">
      <h1 class="title">Tứ trụ huyền cơ</h1>
      <form-input v-if="isModeTyping" @input="setData"/>
      <user-info
        v-else
        :name="name"
        :minute="minute"
        :gender="gender"
        :amlich="dataLunar"
        :duonglich="{year, month, day, hour}"
        :tu-tru-names="tuTruNames"
        :khoi-dai-van="khoiDaiVan"
        :tuoi="laso.curYearOld"
        @onDownload="download"
        @onBack="isModeTyping = true"/>
    </section>
    </div>

    <template v-if="!isModeTyping">
      <div>
        <section id="la-so">
          <carousel
            :margin="10"
            :start-position="0"
            :responsive="responsiveCungmenh"
            class="tu-tru thai-menh"
            :style="{'margin-left': widthItem}"
          >
            <item-tru
              v-for="(tru, index) in truThai"
              :key="index"
              :data="getData(tru)"
              :sao-cung-menh="index === 0 ? tru.saoCungMenh : null"
              :custom-height="customHeight(truThai, true)"
            />
          </carousel>
          <vuong-tuong-huu-tu :data="vuongTuongHuuTu" />
          <h3 class="title">Lá số</h3>
          <carousel
            id="tutruxxx"
            :margin="10"
            :responsive="responsive"
            class="tu-tru">
            <item-tru
              v-for="(tru, index) in tuTru"
              :key="index"
              :data="getData(tru)"
              :custom-height="customHeight(tuTru)"
            />
          </carousel>
        </section>
        <section id="van">
          <div class="box">
            <h3 class="title">Đại vận</h3>
            <carousel
              id="daivan"
              :margin="10"
              :responsive="responsive">
              <item-dai-van
                v-for="(dv, index) in daivan"
                :key="index"
                :index="index"
                :data="getData(dv)"
                :class="{active: daivanId === index}"
                :custom-height="customHeight(daivan)"
                @setDaiVanId="setDaiVan"
              />
            </carousel>
          </div>
          <div
            v-if="luunien"
            class="box" id="t-tieu-van">
            <h3 class="title">Lưu niên - Tiểu vận</h3>
            <carousel
              id="tieuvan"
              :margin="10"
              :responsive="responsive">
              <item-tieu-van
                v-for="(tv, index) in luunien"
                :key="index"
                :index="index"
                :luunien="getData(tv, index)"
                :tieuvan="getData(tieuvan[index], index)"
                :custom-height-ln="customHeight(luunien)"
                :custom-height-tv="customHeight(tieuvan)"
                :class="{active: tieuVanId === index}"
                @onClickTieuVan="onClickTieuVan"
              />
            </carousel>
          </div>
          <div
            v-if="luunienThang"
            class="box" id="t-luu-nien-thang">
            <h3 class="title">Vận tháng</h3>
            <carousel
              id="luunienThang"
              :margin="10"
              :responsive="responsive">
              <item-thang
                v-for="(lnt, index) in luunienThang"
                :key="index"
                :index="index"
                :data="getData(lnt, index)"
                :class="{active: luunienThangId === index}"
                :custom-height="customHeight(luunienThang)"
                @onClickLnThang="onClickLnThang"
              />
            </carousel>
          </div>
          <div
            v-if="luunienNgay"
            class="box" id="t-luu-nien-ngay">
            <h3 class="title">Vận ngày</h3>
            <carousel
              id="luunienNgay"
              :margin="10"
              :responsive="responsive">
              <item-ngay
                v-for="(lnn, index) in luunienNgay"
                :key="index"
                :index="index"
                :data="getData(lnn, index)"
                :class="{active: luunienNgayId === index, 'd-none': index === luunienNgay.length - 1}"
                :custom-height="customHeight(luunienNgay)"
                @onClickLnNgay="onClickLnNgay"
              />
            </carousel>
          </div>
          <div
            v-if="luunienGio"
            class="box" id="t-luu-nien-gio">
            <h3 class="title">Vận giờ</h3>
            <carousel
              id="luunienGio"
              :margin="10"
              :responsive="responsive">
              <item-gio
                v-for="(lng, index) in luunienGio"
                :key="index"
                :index="index"
                :data="getData(lng, index)"
                :custom-height="customHeight(luunienGio)"
              />
            </carousel>
          </div>
        </section>
      </div>
      <div class="mt-5 has-text-centered" v-if="true">
        <button
          class="button"
          :disabled="chartData"
          :class="{'is-loading': isLoadingChart}"
          @click="onClickViewChart">
          Xem Chart
        </button>
        <chart v-if="chartData" class="mt-5" :data="chartData"/>
      </div>
    </template>

    <footer style="display: block; height: 100px;" />

  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import FormInput from '../components/tutru/FormInput'
import UserInfo from '../components/tutru/UserInfo'
import ItemTru from '../components/tutru/ItemTru'
import ItemDaiVan from '../components/tutru/ItemDaiVan'
import ItemTieuVan from '../components/tutru/ItemTieuVan'
import ItemThang from '../components/tutru/ItemThang'
import ItemNgay from '../components/tutru/ItemNgay'
import ItemGio from '../components/tutru/ItemGio'
import VuongTuongHuuTu from '../components/tutru/VuongTuongHuuTu'
import Chart from '../components/tutru/Chart'
import { getDataChart, getLuunienNgay, lapTuTru } from '../utils/tutru/tutru'
export default {
  name: 'TuTru',
  components: {
    carousel,
    FormInput,
    UserInfo,
    ItemTru,
    ItemDaiVan,
    ItemTieuVan,
    ItemThang,
    ItemNgay,
    ItemGio,
    VuongTuongHuuTu,
    Chart
  },
  data () {
    return {
      screenWidth: null,
      widthItem: null,
      name: 'Quang Thắng',
      birthday: '05/02/1996',
      hour: '00',
      minute: '00',
      gender: 1,
      type: 1,
      isModeTyping: true,
      tieuvan: null,
      luunien: null,
      daivanId: null,
      tieuVanId: null,
      luunienThang: null,
      luunienThangId: null,
      luunienNgay: null,
      luunienNgayId: null,
      luunienGio: null,
      lenhThang: null,
      chartData: null,
      isLoadingChart: false,
      responsive: {
        0: {
          items: 1,
          nav: true,
          navText: ['', ''],
          dots: false
        },
        560: {
          items: 2,
          nav: true,
          navText: ['', ''],
          dots: false
        },
        893: {
          items: 3,
          nav: true,
          navText: ['', ''],
          dots: false
        },
        1000: {
          items: 4,
          nav: true,
          navText: ['', ''],
          // navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
          dots: false
        }
      },
      responsiveCungmenh: {
        0: {
          items: 1,
          nav: true,
          navText: ['', ''],
          dots: false
        },
        560: {
          items: 2,
          nav: false,
          dots: false
        },
        893: {
          items: 2,
          nav: false,
          dots: false
        },
        1000: {
          items: 4,
          nav: false,
          dots: false
        }
      }
    }
  },
  computed: {
    day () {
      return parseInt(this.birthday.split('/')[0])
    },
    month () {
      return parseInt(this.birthday.split('/')[1])
    },
    year () {
      return parseInt(this.birthday.split('/')[2])
    },
    laso () {
      return lapTuTru(this.day, this.month, this.year, this.hour, this.minute, this.gender, this.lenhThang)
    },
    dataLunar () {
      return this.laso.dataLunar
    },
    tuTru () {
      return this.laso.tutru.filter((item, idx) => idx > 0 && idx < 5, [])
    },
    truThai () {
      return this.laso.tutru.filter((item, idx) => idx > 4, [])
    },
    tuTruNames () {
      return this.tuTru.map((item) => item.khuCan.thienCan.tenCan + ' ' + item.khuChi.diaChi.tenChi)
    },
    khoiDaiVan () {
      return this.laso.khoiDaiVan
    },
    daivan () {
      return this.laso.daivan
    },
    vuongTuongHuuTu () {
      return this.laso.vuongTuongHuuTu
    },
    params () {
      return this.laso.params
    }
  },
  created () {
    this.getScreenWidth()
    window.addEventListener('resize', this.getScreenWidth)
  },
  watch: {
    isLoadingChart (newVal) {
      if (newVal) {
        setTimeout(() => {
          this.chartData = getDataChart(this.day, this.month, this.year, this.hour, this.minute, this.gender)
          this.isLoadingChart = false
        }, 500)
      }
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.getScreenWidth)
  },
  methods: {
    getScreenWidth () {
      if (this.screenWidth !== document.getElementById('app').clientWidth) {
        this.screenWidth = document.getElementById('app').clientWidth
        this.getWidthOwnItem()
      }
    },
    getWidthOwnItem () {
      this.widthItem = 0
      this.$nextTick(() => {
        const elements = document.getElementsByClassName('owl-item')
        if (elements[3] && this.screenWidth > 1030) {
          this.widthItem = elements[3].style.width
        }
      })
    },
    setData ({ name, birthday, hour, minute, gender, type }) {
      this.isModeTyping = false
      this.name = name
      this.birthday = birthday
      this.hour = hour
      this.minute = minute
      this.gender = gender
      this.type = type

      this.getWidthOwnItem()
    },
    setDaiVan (daivanId) {
      this.daivanId = daivanId
      this.changeLenhThang(this.daivan[daivanId]?.khuChi.diaChi.tenChi)
      this.luunien = this.daivan[daivanId]?.luunien ?? null
      this.tieuvan = this.daivan[daivanId]?.tieuvan ?? null
    },
    onClickTieuVan (tieuVanId) {
      this.tieuVanId = tieuVanId
      this.changeLenhThang(this.luunien[tieuVanId]?.khuChi.diaChi.tenChi)
      this.luunienThang = this.luunien[tieuVanId]?.luunienThang ?? null
    },
    onClickLnThang (luunienThangId) {
      this.luunienThangId = luunienThangId
      this.luunienNgay = getLuunienNgay(this.luunienThang[luunienThangId], this.params)
    },
    onClickLnNgay (luunienNgayId) {
      this.luunienNgayId = luunienNgayId
      this.luunienGio = this.luunienNgay[luunienNgayId]?.luunienGio ?? null
    },
    changeLenhThang (value) {
      this.lenhThang = value
      this.luunien = this.daivan[this.daivanId]?.luunien ?? null
      this.tieuvan = this.daivan[this.daivanId]?.tieuvan ?? null
    },
    getData (data) {
      return {
        title: data.tenTru,
        thapthan: data.khuCan.isNhatChu ? 'Nhật Chủ' : data.khuCan.thapThan,
        truongsinh: data.khuCan.truongSinh,
        truongSinhDong: data.khuCan.truongSinhDong,
        can: {
          name: data.khuCan.thienCan.tenCan,
          class: data.khuCan.thienCan.css,
          amduong: data.khuCan.thienCan.amDuong > 0 ? 'Dương' : 'Âm',
          nguhanh: data.khuCan.thienCan.tenHanh,
          dovuong: data.khuCan.dovuong
        },
        chi: {
          name: data.khuChi.diaChi.tenChi,
          class: data.khuChi.diaChi.css,
          cantangchi: data.khuChi.canTangChi
        },
        tuoi: data.tuoi,
        year: data.year,
        ngayVaoDaiVan: data.ngayVaoDaiVan,
        ngayVaoLuunienNgay: data.ngayVaoLuunienNgay,
        min: data.min,
        max: data.max,
        napam: data.napam,
        nguhanhnapam: data.nguhanhnapam,
        dayOfMonth: data.dayOfMonth,
        cattinh: data.thanSat.cattinh,
        hungtinh: data.thanSat.hungtinh,
        dungthan: data.dungthan.dungthan,
        hithan: data.dungthan.hithan,
        kythan: data.dungthan.kythan
      }
    },
    async download () {
      const el = this.$refs.printMe
      const options = {
        logging: false,
        type: 'dataURL',
        onclone: (data) => {
          const hiddenDiv = data.getElementById('printMe')
          hiddenDiv.style.display = 'block'
          hiddenDiv.style.width = '4200px'

          const elementThaiMenh = data.getElementsByClassName('thai-menh')
          elementThaiMenh[0].style.marginLeft = 0

          var svgElements = data.querySelectorAll('svg')
          svgElements.forEach(function (item) {
            item.setAttribute('width', 4200)
            item.setAttribute('height', 4200)
            item.style.width = null
            item.style.height = null
          })
        }
      }
      await this.$html2canvas(el, options).then((imgUrl) => {
        // var url = imgUrl.replace(/^data:image\/\w+;base64,/, '')
        var a = document.createElement('a')
        a.href = imgUrl // 'data:application/octet-stream;base64,' + encodeURIComponent(url)
        a.target = `${this.name}_${this.hour}h_${this.day}_${this.month}_${this.year}.jpg`
        a.download = `${this.name}_${this.hour}h_${this.day}_${this.month}_${this.year}.jpg`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
    },
    customHeight (tru, excludeFirst = false) {
      const thanSatArr = []
      tru.forEach((item, idx) => {
        if (!excludeFirst || (excludeFirst && idx > 0)) {
          thanSatArr.push(item.thanSat.cattinh.length)
          thanSatArr.push(item.thanSat.hungtinh.length)
        }
      })
      const tinhNum = Math.max(...thanSatArr)
      return tinhNum * 24 + 'px'
    },
    onClickViewChart () {
      this.isLoadingChart = true
    }
  }
}
</script>

<!--<style src="../assets/css/tutruxxx.css" />-->
<!--<style src="../assets/css/_form.css" />-->

<style scoped>
  a.bat-trach {
    text-decoration: underline blue;
    cursor: pointer;
    color: blue;
    font-size: 15px;
  }
  a.bat-trach:hover {
    font-weight: bold;
  }

  /*.html2canvas-container { width: 3000px !important; height: 3000px !important; }*/

  .thai-menh {
    margin-bottom: 15px;
  }

  .d-none, .owl-item .d-none {
    display: none;
  }

</style>
